var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 150,
    viewBox: "0 0 147 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2321",
    opacity: 0.5,
    cx: 73.5372,
    cy: 75.2857,
    r: 64.2857,
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M129.72 28.5373C131.897 29.1601 134.167 27.9001 134.79 25.723C135.413 23.546 134.153 21.2763 131.976 20.6535C129.799 20.0307 127.529 21.2907 126.906 23.4678C126.283 25.6448 127.543 27.9145 129.72 28.5373Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.1934 137.011C25.3705 137.634 27.6402 136.374 28.263 134.197C28.8857 132.02 27.6258 129.75 25.4487 129.128C23.2717 128.505 21.002 129.765 20.3792 131.942C19.7564 134.119 21.0164 136.389 23.1934 137.011Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M139.889 14.8045C141.376 15.2298 142.926 14.3694 143.351 12.8826C143.777 11.3958 142.916 9.8458 141.429 9.42049C139.943 8.99517 138.393 9.85565 137.967 11.3424C137.542 12.8292 138.402 14.3792 139.889 14.8045Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.94356 143.154C8.43032 143.579 9.98037 142.719 10.4057 141.232C10.831 139.745 9.97052 138.195 8.48376 137.77C6.997 137.345 5.44696 138.205 5.02165 139.692C4.59634 141.179 5.4568 142.729 6.94356 143.154Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.9433 23.1541C23.4301 23.5794 24.9801 22.719 25.4054 21.2322C25.8307 19.7455 24.9703 18.1954 23.4835 17.7701C21.9968 17.3448 20.4467 18.2053 20.0214 19.692C19.5961 21.1788 20.4566 22.7288 21.9433 23.1541Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M118.251 44V121.786C106.876 133.058 91.1265 139.87 73.7515 139.87C56.5015 139.87 40.7515 132.934 29.2515 121.786V44H118.251Z",
    fill: "url(#paint0_linear_546_17961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.6,
    d: "M75.3237 83.7037L57.9114 66.4497L51.9894 72.3178L69.4018 89.5718L75.3237 83.7037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.6,
    d: "M89.6057 57.8715L63.6198 83.6211L69.5417 89.4892L95.5276 63.7396L89.6057 57.8715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M96.5013 100.11H51.0013V105.808H96.5013V100.11Z",
    fill: "#E4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M96.5013 112.621H51.0013V118.318H96.5013V112.621Z",
    fill: "#E4E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M85.3766 125.255H62.1266V130.953H85.3766V125.255Z",
    fill: "#E4E9F1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_546_17961",
    x1: 61.4539,
    y1: 199.958,
    x2: 61.4539,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DDEA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImg);
export default __webpack_public_path__ + "static/media/success_img.36da2e7ee2daed7de181e0511fced687.svg";
export { ForwardRef as ReactComponent };